/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProductionFeedback } from './APIProductionFeedback';
import {
    APIProductionFeedbackFromJSON,
    APIProductionFeedbackFromJSONTyped,
    APIProductionFeedbackToJSON,
} from './APIProductionFeedback';

/**
 * 
 * @export
 * @interface APIPaginatedProductionFeedbackList
 */
export interface APIPaginatedProductionFeedbackList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedProductionFeedbackList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedProductionFeedbackList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedProductionFeedbackList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIProductionFeedback>}
     * @memberof APIPaginatedProductionFeedbackList
     */
    results: Array<APIProductionFeedback>;
}

/**
 * Check if a given object implements the APIPaginatedProductionFeedbackList interface.
 */
export function instanceOfAPIPaginatedProductionFeedbackList(value: object): value is APIPaginatedProductionFeedbackList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedProductionFeedbackListFromJSON(json: any): APIPaginatedProductionFeedbackList {
    return APIPaginatedProductionFeedbackListFromJSONTyped(json, false);
}

export function APIPaginatedProductionFeedbackListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedProductionFeedbackList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIProductionFeedbackFromJSON)),
    };
}

export function APIPaginatedProductionFeedbackListToJSON(value?: APIPaginatedProductionFeedbackList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIProductionFeedbackToJSON)),
    };
}

